'use strict';

var count = 0;
module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tinymce/lib/helpers/uuid.js
// module id = 924
// module chunks = 0